import React from "react";

const Close = ({ style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      style={style}
      stroke="currentColor"
    >
      <g id="Raggruppa_406" transform="translate(-1626 -597)">
        <g id="Raggruppa_145" transform="translate(1634.266 606.184)">
          <line
            id="Linea_17"
            x2="15.469"
            y2="15.469"
            fill="none"
            strokeLinecap="round"
            strokeWidth="2"
          />
          <line
            id="Linea_18"
            y1="15.469"
            x2="15.469"
            fill="none"
            strokeLinecap="round"
            strokeWidth="2"
          />
        </g>
      </g>
    </svg>
  );
};

export default Close;
